import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "accommodation-map my-4" };
const _hoisted_2 = { class: "card p-3" };
const _hoisted_3 = {
    key: 0,
    class: "map-container"
};
const _hoisted_4 = { class: "location-info mt-3" };
const _hoisted_5 = { class: "d-flex align-items-center mb-2" };
const _hoisted_6 = { class: "text-muted mb-1" };
const _hoisted_7 = { class: "text-muted mb-0" };
const _hoisted_8 = {
    key: 1,
    class: "no-location"
};
import { computed } from 'vue';
import SimpleMap from '@/components/SimpleMap.vue';
// Props para recibir el hotel
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccommodationMap',
    props: {
        accommodation: {}
    },
    setup(__props) {
        const props = __props;
        // Computed para obtener la información de ubicación
        const accommodationLocation = computed(() => {
            if (!props.accommodation?.place)
                return null;
            return {
                name: props.accommodation.place.name,
                address: props.accommodation.place.address,
                opening_hours: props.accommodation.place.opening_hours,
                contact: props.accommodation.place.contact_info
            };
        });
        // Computed para las coordenadas del hotel
        const accommodationCoordinates = computed(() => {
            if (!props.accommodation?.latitude || !props.accommodation?.longitude) {
                return [-16.2902, -63.5887]; // Coordenadas por defecto de Bolivia
            }
            return [
                parseFloat(props.accommodation.latitude),
                parseFloat(props.accommodation.longitude)
            ];
        });
        // Computed para los marcadores del mapa
        const accommodationMarkers = computed(() => {
            if (!props.accommodation)
                return [];
            return [{
                    id: `hotel-${props.accommodation.id}`,
                    nombre: props.accommodation.title,
                    coordenadas: accommodationCoordinates.value,
                    descripcion: props.accommodation.description,
                    region: props.accommodation.place?.name || 'Bolivia',
                    tipo: 'hotel',
                    destacado: true
                }];
        });
        // Computed para el zoom dinámico
        const accommodationZoom = computed(() => {
            if (!props.accommodation?.place?.name)
                return 10;
            const placeName = props.accommodation.place.name.toLowerCase();
            // Para lugares remotos como el Salar de Uyuni, usar zoom más bajo
            if (placeName.includes('salar') || placeName.includes('uyuni')) {
                return 8;
            }
            // Para lugares en ciudades, usar zoom medio
            if (placeName.includes('oruro') || placeName.includes('la paz') ||
                placeName.includes('cochabamba') || placeName.includes('santa cruz')) {
                return 12;
            }
            // Para otros lugares, zoom por defecto
            return 10;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "mb-3" }, "Ubicación del Hotel", -1)),
                    (accommodationLocation.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(SimpleMap, {
                                center: accommodationCoordinates.value,
                                zoom: accommodationZoom.value,
                                lugares: accommodationMarkers.value,
                                height: "300px"
                            }, null, 8, ["center", "zoom", "lugares"]),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-map-marker-alt text-primary me-2" }, null, -1)),
                                    _createElementVNode("strong", null, _toDisplayString(accommodationLocation.value.name), 1)
                                ]),
                                _createElementVNode("p", _hoisted_6, _toDisplayString(accommodationLocation.value.address), 1),
                                _createElementVNode("p", _hoisted_7, [
                                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-clock me-1" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(accommodationLocation.value.opening_hours), 1)
                                ])
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[2] || (_cache[2] = [
                            _createElementVNode("i", { class: "fas fa-map-marked-alt text-muted mb-2" }, null, -1),
                            _createElementVNode("p", { class: "text-muted" }, "Ubicación no disponible", -1)
                        ])))
                ])
            ]));
        };
    }
});
